import React from "react";

export const UserTokenContext = React.createContext(null);
export const UserDataContext = React.createContext(null);
